export default function coverTable() {
	let table = document.querySelectorAll( 'table' );
	for ( let i = table.length - 1; i >= 0; i -- ) {
		let cover = document.createElement( 'div' );
		cover.classList.add( 'cover-table' );
		table[i].parentNode.insertBefore( cover, table[i] );
		cover.appendChild( table[i] );
	}
}